exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".star-container[data-v-7cdf126b]{background:#fff;padding:12px 0;text-align:center;margin-bottom:13px;cursor:pointer}.star-container[data-v-7cdf126b]:hover{margin:-2px 0 11px;border:2px solid #7f9741}.star-container[data-v-7cdf126b]:active{background:#7f9741}.active[data-v-7cdf126b]{background:#7f9741;margin:-2px 0 11px;border:2px solid #7f9741}label[data-v-7cdf126b]{width:43.6px!important;margin-bottom:0}label[data-v-7cdf126b]:before{font-size:35px!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7cdf126b","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/RestaurantSearchRating.vue
// module id = lkxq
// module chunks = 0 1